import { createSlice } from '@reduxjs/toolkit'
import { updateRebateDate } from 'redux/service/settingsService/rebateDateService';

const initialState = {
  updateRebateDateRes: { data: [], isFetching: false, error: null },
}

export const rebateDateSlice = createSlice({
  name: 'rebateDateSlice',
  initialState,
  extraReducers: (builder) => {
    // builder
    const asyncActionCases = [
      { api: updateRebateDate, name: "updateRebateDateRes" },
    ];
    asyncActionCases.map((asyncAction) => {
      builder
        .addCase(asyncAction.api.fulfilled, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].data = payload;
        })
        .addCase(asyncAction.api.pending, (state) => {
          state[asyncAction.name].isFetching = true;
          state[asyncAction.name].error = null;
        })
        .addCase(asyncAction.api.rejected, (state, { payload }) => {
          state[asyncAction.name].isFetching = false;
          state[asyncAction.name].error = payload;
        });
    });
  },
})


export const { updateRebateDateDispatch } = rebateDateSlice.actions
